import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomValidators } from 'ngx-custom-validators';
import { UserHttpService } from 'src/app/http/user-http.service';
import { EventsService } from 'src/app/services/events.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-user-password-edit',
    templateUrl: './user-password-edit.component.html',
    styles: [],
})
export class UserPasswordEditComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        public location: Location,
        private eventsService: EventsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userHttpService: UserHttpService
    ) {}

    user: any;

    formBusy: boolean;

    password = new FormControl(null, [Validators.required, Validators.minLength(6)]) as any;

    editPasswordForm = this.fb.group(
        {
            newPassword: this.password,
            confirmPassword: [null, [CustomValidators.equalTo(this.password), Validators.required]],
        },
        { updateOn: 'submit' }
    );

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.user = data.data;
        });
    }

    onSubmit() {
        this.editPasswordForm.markAsTouched();
        if (this.editPasswordForm.valid) {
            this.formBusy = true;
            this.userHttpService.resetUserPassword(this.user.email, this.editPasswordForm.value.newPassword).subscribe((data) => {
                this.router.navigateByUrl('user-list', {
                    state: { hasState: true, type: 'success', message: 'Password Updated successfully' },
                });
            });
        }
    }
}
